/* eslint-disable global-require,import/no-mutable-exports */
import bugsnag from '@bugsnag/js';
import { getCookieValue } from './utils';

const debug = require('debug')('jp:bugsnag');
const config = require('../../config/config');

let bugsnagClient;

const clientCheck = !config.isTesting && process.env.BUGSNAG_JS_API_KEY;

if (clientCheck) {
  /**
   * Bugsnag configuration variables
   */
  bugsnagClient = bugsnag({
    apiKey: process.env.BUGSNAG_JS_API_KEY,
    appVersion: config.appVersion,
    releaseStage: process.env.RELEASE_STAGE,
    notifyReleaseStages: ['staging', 'production', 'development'],
    appType: __CLIENT__ ? 'web' : 'server',
    beforeSend: report => {
      if (!__CLIENT__) {
        return;
      }

      report.updateMetaData('JustPark', {
        api_session_id: getCookieValue('api_session_id')
      });
    }
  });
}

/**
 * Notify bugsnag of some information
 * @param error
 * @param opts
 */
export const notify = (error, opts) => {
  if (clientCheck) {
    debug('Notify error', {
      error,
      opts
    });
    return bugsnagClient.notify(error, opts);
  }

  console.error(error);
  return false;
};

/**
 * Set the current bugsnag userId
 */
export const setUser = user => {
  if (clientCheck) {
    debug('Set bugsnag user', user);

    if (!user) {
      bugsnagClient.user = null;
      return;
    }

    bugsnagClient.user = {
      id: user.id,
      name: user.firstName,
      email: user.email
    };
  }
};

export const leaveBreadcrumb = (name, metadata = {}) => {
  if (clientCheck) {
    debug('Leave Breadcrumb', {
      name,
      metadata
    });
    bugsnagClient.leaveBreadcrumb(name, metadata);
  }
};

export default bugsnagClient;
